var _linearGradient, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHygieia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x2: 512,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21dc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dc30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ce07"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256a256 256 0 1 1-512 0 256 256 0 0 1 512 0zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282 90h-5c-15 0-37 7-40 8s-6 3-7 6c-11 6-32 18-32 34 0 3 4 5 10 5 12 0 30-5 34-10 1-3 3-5 5-6 5-2 22-7 31-7 15-1 25 2 31 8 5 5 9 14 8 28a105 105 0 0 1-11 43 164 164 0 0 1-83 80 15 15 0 1 0 12 28l6-3v20l-18 9a15 15 0 0 0 12 27l6-3v20a77 77 0 0 1-41 15c-1 0-7 1-12-1-7-3-10-6-11-13a15 15 0 1 0-29 6c3 17 14 30 31 35a64 64 0 0 0 26 3h102a15 15 0 0 0 0-30h-35l22-14a15 15 0 1 0-14-26l-9 5v-16l24-16a15 15 0 1 0-17-25l-7 5v-18c41-4 79-21 111-51 25-23 38-46 38-47a15 15 0 0 0-13-22h-27a15 15 0 0 0-2 29c-13 16-35 37-65 50l8-12c17-25 26-55 26-78 0-22-6-39-17-50s-27-16-48-16zm-177 77a15 15 0 0 0-13 22c1 2 32 58 95 85a15 15 0 1 0 12-28c-30-13-52-33-65-49h145c8 0 14-9 14-16 0-6-6-14-14-14z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHygieia);
export default __webpack_public_path__ + "static/media/hygieia.dab3f90b21326ea6a9b72f109a1e9788.svg";
export { ForwardRef as ReactComponent };